/* ログ一覧検索結果リスト */
import React, { useState, memo } from 'react';
import { Grid, _ } from 'gridjs-react';
import { KeyValue } from '../types/KeyValue';
import { PopsLogList } from '../types/LogList';

type Props = {
  projects: Array<KeyValue[]>;
  config: PopsLogList;
};

const LogResultList: React.FC<Props> = ({ projects, config }) => {
  const [rows, setRows] = useState(10);
  const onChangeLimit = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setRows(Number(event.target.value));
  };
  return (
    <>
      <div className="row my-2">
        <div className="col-md-12">
          <span className="search-criteria-head">表示件数</span>
          <select
            name="表示件数"
            className="search-form-input"
            onChange={onChangeLimit}
            value={rows}
          >
            {config.display_list_number.map((num: number, index: number) => {
              return (
                <option key={index} value={num}>
                  {num}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <Grid
        data={projects}
        columns={[
          {
            id: 'created_at',
            name: '発生時間',
            width: '100px',
          },
          {
            id: 'error_level',
            name: 'エラーレベル',
          },
          {
            id: 'reception_cd',
            name: '案件コード',
          },
          {
            id: 'reception_sub_cd',
            name: '案件サブコード',
          },
          {
            id: 'message_code',
            name: 'メッセージID',
          },
          {
            id: 'message',
            name: 'メッセージ',
            formatter: cell =>
              _(
                cell
                  ?.toString()
                  .split('\\n')
                  .map(x => <div>{x}</div>)
              ),
          },
          {
            id: 'operation',
            name: '処理パス',
          },
          {
            id: 'src_address',
            name: '接続情報',
          },
        ]}
        search={false}
        sort={true}
        pagination={{
          enabled: true,
          limit: rows,
        }}
        fixedHeader={true}
      />
    </>
  );
};

export default memo(LogResultList);
